// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"6b22a1db","122":"ed953a4d","387":"526d8593","571":"e957ac6f","842":"5775c01e"}[chunkId] + ".chunk.js";
};